import { Suspense } from 'react';
import { pageRegistry, PageModels } from './pages/registry';
import { getAppConfig } from '@/core/config/get-app-config';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@/core/components';

function App() {
	const { t } = useTranslation();
	const config = getAppConfig();
	const pageToLoad = config?.page_to_load;

	// Type guard: ensure it's a known page key
	if (!pageToLoad || !(pageToLoad in pageRegistry)) {
		return <div>{t('common.noPageToLoad')}</div>;
	}

	// Use assertion to help TypeScript narrow the key
	const pageKey = pageToLoad as keyof typeof pageRegistry;

	const { component: PageComponent, getModel } = pageRegistry[pageKey];

	// Narrow model type correctly
	const initialData = window.__INITIAL_DATA__ as PageModels[typeof pageKey];
	const model = getModel(initialData);

	return (
		<Suspense fallback={<Spinner />}>
			<PageComponent model={model} />
		</Suspense>
	);
}

export default App;
